<script>
  import { phoneWidth } from './stores.js';

  const toTheTop = () => {
    window.scrollTo(0, 0);
  };
  let scrollY = 0;
  let innerHeight;
  const clamp = (num, min, max) => Math.min(Math.max(num, min), max);
  const makeColorCode = (ratio) => {
    const hex = Math.round(ratio * 255);
    const clamped = clamp(hex, 0, 255);
    return `rgba(${clamped}, ${clamped}, ${clamped})`;
  };
  $: scrolledRatio =
    innerHeight - scrollY > 0 ? (innerHeight - scrollY) / innerHeight : 0;
  $: color = makeColorCode(scrolledRatio);
  // const maxOpacity = window.innerwidth <= phoneWidth ? 1.0 : 0.9;
  const maxOpacity = 0.8;
  $: navOpacity = clamp((1 - scrolledRatio) * maxOpacity, 0, maxOpacity);

  const handleHeaderEnter = () => {
    navOpacity = 1;
    color = '#333';
  };
  const handleHeaderLeave = () => {
    navOpacity = clamp((1 - scrolledRatio) * maxOpacity, 0, maxOpacity);
    color = makeColorCode(scrolledRatio);
  };
</script>

<svelte:window bind:scrollY bind:innerHeight />

<!-- <svelte:window
  bind:scrollY={posY}
  on:scroll={() => {
    scrollerY;
  }}
/> -->

<header
  id="main-header"
  class="main-header"
  style="transition:300ms; background-color: rgba( 252, 252, 252,{navOpacity});
box-shadow: 0px 0px 5px rgba(3,3,3,{navOpacity});"
  on:mouseenter={handleHeaderEnter}
  on:mouseleave={handleHeaderLeave}
>
  <span class="logo-container" on:click={toTheTop}>
    <span class="main-logo" style="color:{color};">황금메쥬</span>
    <p style="color:{color};">GOLDEN MEJU</p>
  </span>

  <span class="logo-line" />

  <nav>
    <a style="color:{color};" href="#intro" class="nav-link intro">소개</a>
    <a style="color:{color};" href="#price" class="nav-link price">가격표</a>
    <a style="color:{color};" href="#location" class="nav-link location"
      >위치&일정</a
    >
    <a style="color:{color};" href="#reservation" class="nav-link contact"
      >예약</a
    >
  </nav>
</header>

<style>
  .main-header {
    top: 0;
    position: fixed;
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    padding: 8px 0px;
    z-index: 1000;

    transition: transform 300ms linear;
  }

  .nav-link {
    color: whitesmoke;
    font-weight: 100;
    font-size: 22px;
  }

  .logo-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-left: 50px;
    color: #fcfcfc;
  }
  .logo-container:hover {
    cursor: pointer;
  }

  .main-header .main-logo {
    display: block;
    font-weight: 400;
    font-size: 32px;
  }
  .main-header p {
    font-weight: 100;
    font-size: 12px;
    margin: 0 auto;
  }

  nav {
    display: flex;
    gap: 36px;
    margin-right: 55px;
  }

  @media screen and (max-width: 768px) {
    .main-header {
      flex-direction: column;
      padding: 0;
    }

    .logo-container {
      margin: 0;
    }

    .main-header .main-logo {
      font-size: 22px;
      margin: 7px 0px;
      margin-top: 10px;
    }

    .main-header .logo-container p {
      display: none;
    }

    .logo-line {
      display: block;
      width: 100%;
      border-top: 1px solid #777;
      /* margin-bottom: 5px; */
    }

    nav {
      margin: 6px 0px;
      width: 100%;
      justify-content: space-evenly;
    }
    .nav-link {
      font-size: 18px;
    }
  }
</style>
